import { NormalizedGroup } from '../../../redux/groups/api/GroupAdapter';
import { getDictionaryGroups } from '../../../redux/groups/selectors';
import { useAppSelector } from '../../../redux/store.model';
import { useMemo } from 'react';
import { GroupType } from '../redux/group/model';

export const useGetChildCount = (group: NormalizedGroup) => {
  const groupsById = useAppSelector(getDictionaryGroups);

  const { storesCount, merchandisersCount } = useMemo(() => {
    const rootGroup = groupsById[group.id] ?? group;
    const visited = new Set<string>();

    const countChildrenRecursively = (currentGroup: NormalizedGroup) => {
      if (visited.has(currentGroup.id)) {
        return { storesCount: 0, merchandisersCount: 0 };
      }

      visited.add(currentGroup.id);

      let stores = 0;
      let merchandisers = 0;

      for (const childGroupId of currentGroup.childGroups ?? []) {
        const childGroup = groupsById[childGroupId];
        if (!childGroup) continue;
        const businessRole =
          childGroup.attributes?.BUSINESS_ROLE === GroupType.Store;

        if (businessRole) {
          stores += 1;
        } else if (childGroup.composableDevice !== undefined) {
          merchandisers += 1;
        }

        const childCounts = countChildrenRecursively(childGroup);
        stores += childCounts.storesCount;
        merchandisers += childCounts.merchandisersCount;
      }

      return { storesCount: stores, merchandisersCount: merchandisers };
    };

    return countChildrenRecursively(rootGroup);
  }, [group.id, groupsById]);

  return {
    storesCount,
    merchandisersCount,
  };
};
